import {
  GET_DRIVERS_STATS,
  GET_DRIVERS_STATS_ERROR
} from "../constants/StatsConstants";

const INITIAL_STATE = {
  driverStats: null,
  loading: true
};
const driverStatsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_DRIVERS_STATS:
      return {
        ...state,
        driverStats: action.payload,
        loading: false
      };
    case GET_DRIVERS_STATS_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export default driverStatsReducer;
